<template>
  <div class="jumbotron">
    <div class="login-container">
      <div class="row justify-content-md-center">
        <div class=" col-sm-6 col-lg-4">
          <div v-if="alert.message" :class="`alert ${alert.type}`">{{alert.message}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-lg-4 offset-lg-4 mb-4">
          <div class="panel panel-login">
            <div class="panel-heading" style="padding-top: 1em;">
              <div class="row">
                <div :class="{'col-6': registerEnabled, 'col-12': !registerEnabled}">
                  <a href="#" class="active" id="login-form-link">{{$t('login.signin')}}</a>
                </div>
                <div v-if="registerEnabled" class="col-6">
                  <a href="#" id="register-form-link">{{$t('login.signup')}}</a>
                </div>
              </div>
              <hr>
            </div>
            <div class="panel-body" style="padding: 1em;">
              <div class="row">
                <div class="col-lg-12">
                  <form @submit.prevent="handleSubmitLogin" data-vv-scope="form-login" id="login-form" style="display: block;">
                    <div class="form-group">
                      <label htmlFor="phone">{{ $t('register.phone') }}</label>
                      <div class="input-group mb-3">
                        <input type="text" v-model="phone_str" v-validate="{ required: true, min: 10 }" name="phone" class="form-control phone-text" :class="{ 'is-invalid': submitted && errors.has('form-login.phone') }" :data-vv-as="$t('register.phone')" @input="acceptNumberLogin"/>
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon1">98+</span>
                        </div>
                        <div v-if="submitted && errors.has('form-login.phone')" class="invalid-feedback">{{ errors.first('form-login.phone') }}</div>
                      </div>
                    </div>
                    <div class="form-group">
                      <img v-show="status.loggingIn || status.registering" class="ml-2" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                      <button class="btn btn-primary">{{ $t('login.login') }}</button>
                    </div>
                  </form>
                  <form v-if="registerEnabled" @submit.prevent="handleSubmitRegister" data-vv-scope="form-register" id="register-form" style="display: none;">
                    <div class="form-group">
                      <label htmlFor="reg-phone">{{ $t('register.phone') }}</label>
                      <div class="input-group mb-3">
                        <input type="text" v-model="user.phone_str" v-validate="{ required: true, min: 10 }" name="reg-phone" class="form-control phone-text" :class="{ 'is-invalid': submitted && errors.has('form-register.reg-phone') }" :data-vv-as="$t('register.phone')" @input="acceptNumberRegister"/>
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon1">98+</span>
                        </div>
                        <div v-if="submitted && errors.has('form-register.reg-phone')" class="invalid-feedback">{{ errors.first('form-register.reg-phone') }}</div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="first_name">{{ $t('register.first_name') }}</label>
                      <input type="text" v-model="user.first_name" v-validate="'required'" name="first_name" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-register.first_name') }" :data-vv-as="$t('register.first_name')"/>
                      <div v-if="submitted && errors.has('form-register.first_name')" class="invalid-feedback">{{ errors.first('form-register.first_name') }}</div>
                    </div>
                    <div class="form-group">
                      <label for="last_name">{{ $t('register.last_name') }}</label>
                      <input type="text" v-model="user.last_name" v-validate="'required'" name="last_name" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-register.last_name') }" :data-vv-as="$t('register.last_name')"/>
                      <div v-if="submitted && errors.has('form-register.last_name')" class="invalid-feedback">{{ errors.first('form-register.last_name') }}</div>
                    </div>
                    <div class="form-group">
                      <label htmlFor="birthdate_str">{{ $t('register.birthdate') }}</label>
                      <DatePicker v-model="user.birthdate_str" v-validate="{ required: true }" name="birthdate_str" id="birthdate-text" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-register.birthdate_str') }" :data-vv-as="$t('register.birthdate')"/>
                      <div v-if="submitted && errors.has('form-register.birthdate_str')" class="invalid-feedback">{{ errors.first('form-register.birthdate_str') }}</div>
                    </div>
                    <div class="form-group">
                      <label htmlFor="gender">{{ $t('register.gender') }}</label>
                      <select name="gender" id="gender" class="form-control" v-model="user.gender" v-validate="{ required: true }" :class="{ 'is-invalid': submitted && errors.has('form-register.gender') }" :data-vv-as="$t('register.gender')">
                        <option value="2" selected="selected">{{ $t('gender.male') }}</option>
                        <option value="1">{{ $t('gender.female') }}</option>
                        <option value="0">{{ $t('gender.other') }}</option>
                      </select>
                      <div v-if="submitted && errors.has('form-register.gender')" class="invalid-feedback">{{ errors.first('form-register.gender') }}</div>
                    </div>
                    <div class="form-group">
                      <label htmlFor="role">{{ $t('register.role') }}</label>
                      <select name="role" id="role" class="form-control" v-model="user.role" v-validate="{ required: true }" :class="{ 'is-invalid': submitted && errors.has('form-register.role') }" :data-vv-as="$t('register.role')">
                        <option value="0" selected="selected">{{ $t('role.doctor') }}</option>
                      </select>
                      <div v-if="submitted && errors.has('form-register.role')" class="invalid-feedback">{{ errors.first('form-register.role') }}</div>
                    </div>
                    <div class="form-group">
                      <img v-show="status.loggingIn || status.registering" class="ml-2" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                      <button class="btn btn-primary">{{ $t('register.register') }}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueAgile from 'vue-agile/src/Agile.vue'
/* eslint-disable */
import { mapState, mapActions } from 'vuex'
import { store } from '@/_store'
import DatePicker from '@/components/DatePicker.vue'

export default {
  components: {
    'agile': VueAgile,
    DatePicker
  },
  data () {
    return {
      registerEnabled: false,
      activeTab: 0,
      phone_str: '',
      phone: '',
      user: {
        first_name: '',
        last_name: '',
        phone_str: '',
        phone: '',
        birthdate_str: '',
        birthdate: 0,
        gender: 0,
        role: 0
      },
      submitted: false,
      slickOptions: {
        arrows: false,
        dots: true
      },
      unsubscribe: null
    }
  },
  computed: {
    ...mapState('account', ['status']),
    ...mapState({
      alert: state => state.alert
    })
  },
  created () {
    this.logout()

    var verifyMsg = this.$t('login.verify_msg')
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'account/registerSuccess') {
        setTimeout(() => {
          // display success message after route change completes
          store.dispatch('alert/success', verifyMsg, { root: true })
        })
      }
    })
  },
  destroyed () {
    this.unsubscribe()
  },
  mounted () {
    $('body').addClass('loaded');
    $('#login-form-link').click(function(e) {
      $("#login-form").delay(100).fadeIn(100)
      $("#register-form").fadeOut(100)
      $('#register-form-link').removeClass('active')
      $(this).addClass('active')
      e.preventDefault()
    })

    $('#register-form-link').click(function(e) {
      $("#register-form").delay(100).fadeIn(100)
      $("#login-form").fadeOut(100)
      $('#login-form-link').removeClass('active')
      $(this).addClass('active')
      e.preventDefault()
    })
  },
  methods: {
    ...mapActions('account', ['login', 'logout', 'register']),
    ...mapActions({
      clearAlert: 'alert/clear'
    }),
    translate(input) {
      var hindi = ['۰','۱','۲','۳','۴','۵','۶','۷','۸','۹'];
      var arabic = [0,1,2,3,4,5,6,7,8,9];
      var array = input.split('');
      array.map(function(value, i, array) {
        if (hindi.indexOf(array[i]) >= 0) {
          array[i] = arabic[hindi.indexOf(array[i])];
        }
      });
      return array.join('');
    },
    acceptNumberLogin() {
      var x = this.phone_str.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.phone_str = !x[2] ? x[1] : x[1] + ' ' + x[2] + (x[3] ? ' ' + x[3] : '');
    },
    acceptNumberRegister() {
      var x = this.user.phone_str.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.user.phone_str = !x[2] ? x[1] : x[1] + ' ' + x[2] + (x[3] ? ' ' + x[3] : '');
    },
    handleSubmitRegister (e) {
      this.submitted = true

      // work around for not changing model after user selects date from date picker
      var bdatestr = $("#birthdate-text").val()
      if (bdatestr.length > 0) {
        this.user.birthdate_str = bdatestr
      }

      this.$validator.validateAll('form-register').then(valid => {
        if (valid) {
          // calculate timestamp for birthdate field
          var x = this.translate(bdatestr).match(/(\d{0,4})\/(\d{0,2})\/(\d{0,2})/)
          if (x.length < 4) {
            // date not valid
            return
          }
          var birthdate = new persianDate(x[1], x[2], x[3]).startOf('day').format('X')
          this.user.birthdate = parseInt(birthdate)
          this.user.phone = "98" + this.user.phone_str.replace(/\s/g, '')

          this.register(this.user)
          this.activeTab = 0 
        }
      })
    },
    handleSubmitLogin (e) {
      this.submitted = true
      this.$validator.validateAll('form-login').then(valid => {
        console.log(valid, this.errors, this.errors.has('form-login.phone'), this.errors.first('form-login.phone'))
        if (valid) {
          this.phone = "98" + this.phone_str.replace(/\s/g, '')
          if (this.phone) {
            this.login({ phone: this.phone })
          }
        }
      })
    }
  },
  watch: {
    $activeTab (to, from) {
      // clear alert on location change
      // this.clearAlert()
    }
  }
}
</script>

<style>
.phone-text {
  direction: ltr;
  text-align: center;
  letter-spacing: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue